import { render, staticRenderFns } from "./helm.cattle.io.projecthelmchart.vue?vue&type=template&id=af7b5e80&scoped=true&"
import script from "./helm.cattle.io.projecthelmchart.vue?vue&type=script&lang=js&"
export * from "./helm.cattle.io.projecthelmchart.vue?vue&type=script&lang=js&"
import style0 from "./helm.cattle.io.projecthelmchart.vue?vue&type=style&index=0&id=af7b5e80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7b5e80",
  null
  
)

export default component.exports